export default __webpack_public_path__ + "static/media/icon_presentation.a92fb82d.png";